import {
  Directive,
  HostListener,
  ElementRef,
  inject,
  output,
} from '@angular/core';

@Directive({ selector: '[clickOutside]' })
export class ClickedOutsideDirective {
  private elemRef = inject(ElementRef);

  readonly clickOutside = output<Event>();

  // when clicking an element in the document
  @HostListener('document:click', ['$event'])
  onClick(event) {
    // if it's not the reference element or one of it's children
    if (!this.elemRef.nativeElement.contains(event.target)) {
      // let the reference element know a click outside happened
      this.clickOutside.emit(event);
    }
  }

  // when pressing escape emit a clickOutside event
  // this will emit/tie to each element using this directive (shouldn't be a perf issue but keep in mind)
  @HostListener('window:keyup.escape', ['$event'])
  onEscape(event) {
    // let the ref element know a "click" outside happened and it should close
    this.clickOutside.emit(event);
  }

  constructor() {}
}
